import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";

const CustomNodeQRConfig = ({ data }) => {

  return (
    <div className="custom-node">
      <div className="node-header">QR CONFIG</div>

      <div>{data?.operation}</div>

      <Handle type="target" position="left" />
      <Handle type="source" position="right" />
    </div>
  );
};

export default CustomNodeQRConfig;
